import React, { useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import HumanBody3D from './HumanBody3D/HumanBody3D';
import { useHeroLoader } from '../../../hooks/useHeroLoader';
import './Hero.css';

interface HeroProps {
  onHeroLoaded?: () => void;
}

const Hero: React.FC<HeroProps> = ({ onHeroLoaded }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const { loadingState, textContentRef, threeJSRef, isHeroLoaded } = useHeroLoader();

  // Notify parent when Hero is fully loaded
  useEffect(() => {
    if (isHeroLoaded && onHeroLoaded) {
      onHeroLoaded();
    }
  }, [isHeroLoaded, onHeroLoaded]);

  return (
    <motion.section 
      className='hero cinquity-hero'
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.7, ease: 'easeOut' }}
    >
      <div className='hero-background'>
        <div className='hero-pattern'></div>
        <div className='floating-particles'>
          <div className='particle particle-1'></div>
          <div className='particle particle-2'></div>
          <div className='particle particle-3'></div>
          <div className='particle particle-4'></div>
          <div className='particle particle-5'></div>
          <div className='particle particle-6'></div>
          <div className='particle particle-7'></div>
          <div className='particle particle-8'></div>
          <div className='particle particle-9'></div>
          <div className='particle particle-10'></div>
        </div>
      </div>
      <div className='hero-content'>
        <div ref={textContentRef}>
          <div className='hero-badge'>
            <span>Smart eCOA Solution</span>
          </div>
          <h1 className='hero-title'>
            Bring Drugs to Patients Faster with{' '}
            <span className='highlight'>AI-Powered eCOA</span>
          </h1>
          <p className='hero-subtitle'>
            Transform lives by accelerating breakthrough treatments from lab to bedside. 
            Our AI-powered platform streamlines clinical trials so patients get the 
            life-saving therapies they need, when they need them most.
          </p>
          <div className='hero-features'>
            <div className='hero-feature'>
              <span className='feature-text'>AI-Powered Validation</span>
            </div>
            <div className='hero-feature'>
              <span className='feature-text'>Multi-Device Support</span>
            </div>
            <div className='hero-feature'>
              <span className='feature-text'>FDA 21 CFR Part 11 Compliant</span>
            </div>
            <div className='hero-feature'>
              <span className='feature-text'>Real-Time Analytics</span>
            </div>
          </div>
        </div>
      </div>
      <div className='hero-3d-visual' ref={threeJSRef}>
        <HumanBody3D />
      </div>
    </motion.section>
  );
};

export default Hero;
